<template>
  <div class="left">
    <ul class="person-center">
      <li class="f18 font-MT text-fff mb10" v-for="(item, index) in navlist" :key="item.name">
        <router-link
                v-if="item.url"
                :to="item.url"
                class="text-fff flexible aItem-center"
                :class="{ active: oIndex == index, link: link }"
        >
            <img class="slider-icon" :src="item.icon" />
            <span class="sidebar-name">{{ item.name }}<i v-if="noticeNum >0&&item.url == '/message'" class="notice-num"></i></span>
        </router-link>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  props: {
      noticeNum: Number,
    isSmall: Boolean,
    oIndex: Number,
    link: Boolean,
    isSet: Boolean,
    isAuthor: Boolean,
    totalPage: Number,
    sAuthor: Boolean
  },
  data () {
    return{
      navlist: [
        { url: "/author", name: this.$lang('authorCenter.stories.title'),icon: require('@/assets/author/Stories.png') },
        { url: "/income", name: this.$lang('authorCenter.income.title'),icon: require('@/assets/author/Income.png')},
        { url: "/message", name: this.$lang('authorCenter.inbox.title'),icon:require('@/assets/author/Comments.png') },
        { url: "/info", name: this.$lang('authorCenter.profile.title'),icon: require('@/assets/author/information.png') },
      ],
    }
  },
  computed: mapState({
    info: state => (state.user.img ? state.user.img : null)
  }),
  methods: {
    bookendhint() {
      this.$emit("isShowhint", true);
    },
  }
};
</script>

<style lang="scss" scoped>
  @import "@/styles/author.scss";
</style>
